import styled from 'styled-components';

import SAYT from '../../Components/Form/SAYT';

export const StyledSAYT = styled(SAYT)`
    width: 100%;
`;